import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconClose, IconGithub, IconMenu } from '@arco-design/web-react/icon';
import { LanguageContext, LanguageEnum, getCDNDomain } from '../../utils';

import './index.less';

interface IProps {
  style?: React.CSSProperties;
  title: React.ReactNode;
  items: React.ReactNode[];
  className?: string;
}

export function NavigatorMobile(props: IProps) {
  const { language, setLanguage } = useContext(LanguageContext);
  const navigate = useNavigate();
  const [dropDown, setDropDown] = useState<boolean>(false);

  return (
    <div
      className="mobile-navigator-container"
      style={{ zIndex: 1, ...(props.style ?? {}) }}
    >
      <div className="mobile-navigator-inner-container">
        <div className="mobile-navigator-left">
          <div
            style={{ marginRight: 60, cursor: 'pointer', height: 24 }}
            onClick={() => navigate('/')}
          >
            <img
              src={`${getCDNDomain()}/img/visactor/navigator-logo.svg`}
              style={{ height: 24 }}
            />
          </div>
        </div>
        <div className="mobile-navigator-right">
          <div
            className="mobile-navigator-tool"
            style={{ marginLeft: 12 }}
            onClick={() => {
              if (language === LanguageEnum.chinese) {
                setLanguage(LanguageEnum.english);
              } else {
                setLanguage(LanguageEnum.chinese);
              }
            }}
          >
            <img
              src={
                language === LanguageEnum.chinese
                  ? `${getCDNDomain()}/img/common/language-ch.svg`
                  : `${getCDNDomain()}/img/common/language-en.svg`
              }
              style={{ height: 14, marginTop: 4 }}
            />
          </div>
          <div className="mobile-navigator-tool" style={{ marginLeft: 12 }}>
            <IconGithub
              style={{ width: 16, height: 16, marginTop: 2 }}
              onClick={() => {
                window.open('https://github.com/VisActor');
              }}
            />
          </div>
          <div className="mobile-navigator-tool" style={{ marginLeft: 12 }}>
            <IconMenu
              style={{ width: 20, height: 20, marginTop: 2 }}
              onClick={() => setDropDown(true)}
            />
          </div>
        </div>

        {dropDown ? (
          <div
            style={{
              width: '100vw',
              height: '100vh',
              position: 'fixed',
              left: 0,
              top: 0,
              zIndex: 100,
              background: '#fff',
            }}
          >
            <div
              style={{
                height: 62,
                display: 'flex',
                alignItems: 'center',
                position: 'relative',
              }}
            >
              <IconClose
                style={{
                  width: 20,
                  height: 20,
                  float: 'right',
                  position: 'absolute',
                  right: 20,
                  top: 20,
                }}
                onClick={() => setDropDown(false)}
              />
            </div>
            <div className="mobile-navigator-link-title">{props.title}</div>
            {(props.items ?? []).map((item) => {
              return <div className="mobile-navigator-link">{item}</div>;
            })}
          </div>
        ) : null}
      </div>
    </div>
  );
}
